import { Component} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrl: './our-team.component.css'
})
export class OurTeamComponent {
  //Team Members
  teamMembers = [
    {
      name: "Sarah Doe",
      role: "Creative Director",
      image: "team-1.jpg",
      socials: [
        { icon: "fab fa-x-twitter", link: "/our-team" },
        { icon: "fab fa-facebook-f", link: "/our-team" },
        { icon: "fab fa-instagram", link: "/our-team" },
        { icon: "fab fa-linkedin-in", link: "/our-team" }
      ]
    },
    {
      name: "Aaron Doe",
      role: "Lead Web Developer",
      image: "team-2.jpg",
      socials: [
        { icon: "fab fa-x-twitter", link: "/our-team" },
        { icon: "fab fa-facebook-f", link: "/our-team" },
        { icon: "fab fa-instagram", link: "/our-team" },
        { icon: "fab fa-linkedin-in", link: "/our-team" }
      ]
    },
    {
      name: "Anis Doe",
      role: "UI/UX Designer",
      image: "team-3.jpg",
      socials: [
        { icon: "fab fa-x-twitter", link: "/our-team" },
        { icon: "fab fa-facebook-f", link: "/our-team" },
        { icon: "fab fa-instagram", link: "/our-team" },
        { icon: "fab fa-linkedin-in", link: "/our-team" }
      ]
    },
    {
      name: "Emily White",
      role: "QA Engineer",
      image: "team-4.jpg",
      socials: [
        { icon: "fab fa-x-twitter", link: "/our-team" },
        { icon: "fab fa-facebook-f", link: "/our-team" },
        { icon: "fab fa-instagram", link: "/our-team" },
        { icon: "fab fa-linkedin-in", link: "/our-team" }
      ]
    },
    {
      name: "Frank Green",
      role: "Project Manager",
      image: "team-5.jpg",
      socials: [
        { icon: "fab fa-x-twitter", link: "/our-team" },
        { icon: "fab fa-facebook-f", link: "/our-team" },
        { icon: "fab fa-instagram", link: "/our-team" },
        { icon: "fab fa-linkedin-in", link: "/our-team" }
      ]
    },
    {
      name: "Alice Johnson",
      role: "Lead Web Developer",
      image: "team-6.jpg",
      socials: [
        { icon: "fab fa-x-twitter", link: "/our-team" },
        { icon: "fab fa-facebook-f", link: "/our-team" },
        { icon: "fab fa-instagram", link: "/our-team" },
        { icon: "fab fa-linkedin-in", link: "/our-team" }
      ]
    }
  ];

  // OWl Slider
    brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "vendor-1.jpg"},
    {img: "vendor-2.jpg"},
    {img: "vendor-3.jpg"},
    {img: "vendor-4.jpg"},
    {img: "vendor-5.jpg"},
    {img: "vendor-6.jpg"}
  ];
}
